export default __webpack_public_path__ + "static/high-five-e5acfbbf58681514291fb04ac2bd8d50.png";